<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useColors } from 'vuestic-ui'

const { applyPreset, currentPresetName } = useColors()

onMounted(() => {
  if (currentPresetName.value !== 'dark') {
    applyPreset('dark')
  }
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
